import { Button } from "primereact/button";
import { Column } from "primereact/column";

export const editorColumn = ({
  enabled,
  headerStyle,
  frozen,
  disabledMessage,
}: {
  enabled: boolean;
  headerStyle: React.CSSProperties;
  frozen?: boolean;
  disabledMessage: string | undefined;
}) =>
  enabled ? (
    <Column
      key="editor-enabled"
      columnKey="editor-enabled"
      rowEditor
      frozen={frozen}
      bodyStyle={{ textAlign: "center" }}
      headerStyle={headerStyle}
    />
  ) : (
    <Column
      key="editor-disabled"
      columnKey="editor-disabled"
      rowEditor
      frozen={frozen}
      body={
        <Button
          rounded
          text
          severity="secondary"
          disabled
          icon="pi pi-pencil"
          tooltip={disabledMessage}
          tooltipOptions={{ showDelay: 500, showOnDisabled: true }}
          style={{
            width: "24px",
            height: "24px",
          }}
        />
      }
      bodyStyle={{ textAlign: "center" }}
      headerStyle={headerStyle}
    />
  );
